import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/upload`

    return {
        show(queryParms = {}) {
            return repository.get(`${baseUrl}/show?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}/destroy`)
        },
        download(id) {
            return repository.get(`${baseUrl}/${id}/download`, { responseType: "arraybuffer" })
        },
        view(id) {
            return repository.get(`${baseUrl}/${id}/view`, { responseType: "arraybuffer" })
        },
    }
}
